<template>
  <div class="pivot-config-group" :class="mode">
    <template v-if="mode === 'dropdown'">
      <!-- <div class="header">
        <div class="title">{{ role }}</div>
        <dim-picker @select="(dim)=>addDimension(dim)" />
      </div>
       -->
      <dropdown-list
        :title="$t('table_' + role)"
        :can-add="activeDimensions.length < maxItems"
        :has-add="role !== 'filters'"
        :other-dims="inactiveDimensions"
        :max-items="maxItems"
        @add="addDimension"
      >
        <template v-slot:list>
          <draggable
            v-model="activeDimensions"
            group="dimensions"
            v-bind="dragOptions"
            :move="checkMove"
            :data-type="role"
            :data-max-items="maxItems"
          >
            <div
              v-for="dim in activeDimensions"
              :key="dim.id"
              :data-id="dim.id"
              class="filter"
              :class="[canDrag(dim) ? 'drag-handle' : 'nodrag', canEdit(dim) ? '' : 'noedit']"
            >
              <template v-if="metas[dim.id].type === 'location' || metas[dim.id].type === 'time'">
                <typed-filter-box
                  :dimension="dim"
                  :type-dimension="typeDimensions.find(d => d.id === dim.id + '_type')"
                  :options="restrictedOptions[dim.id]"
                  :type-options="typeDimOptions[dim.id]"
                  :meta="metas[dim.id]"
                  :multiple-types="
                    dim.role !== 'filters' &&
                      metas[dim.id].type === 'location' &&
                      !getChartUtil(chartType).forceSngleTypes
                  "
                  @changeType="
                    newDim =>
                      onTypeDimChange(
                        typeDimensions.find(d => d.id === dim.id + '_type'),
                        newDim
                      )
                  "
                  @change="newDim => onDimChange(dim, newDim)"
                  @remove="removeDimension"
                />
              </template>
              <template v-else>
                <filter-box
                  :dimension="dim"
                  :options="restrictedOptions[dim.id]"
                  :meta="metas[dim.id]"
                  @change="newDim => onDimChange(dim, newDim)"
                  @remove="removeDimension"
                />
              </template>
            </div>
            <div v-if="role === 'filters' && activeDimensions.length === 0" class="no-dims-message">
              No more dimensions
            </div>
            <div
              v-if="role !== 'filters' && activeDimensions.length < maxItems"
              class="drag-more-message"
            >
              {{ $t('drag_dimensions') }} (Max. {{ maxItems }})
            </div>
          </draggable>
        </template>
      </dropdown-list>
    </template>
    <template v-if="mode === 'quick'">
      <template v-if="role === 'filters'">
        <quick-filter
          v-for="dim in activeDimensions.filter(dim => restrictedOptions[dim.id].length)"
          :key="dim.id"
          v-model="dim.values"
          :meta="metas[dim.id]"
          :options="restrictedOptions[dim.id]"
        />
      </template>
      <template v-else-if="role === 'types'">
        <quick-filter
          v-for="dim in activeDimensions"
          :key="dim.id"
          v-model="dim.values"
          :meta="metas[dim.id.replace('_type', '')]"
          :options="restrictedOptions[typeDimensions.find(d => d.id === dim.id).id]"
        />
      </template>
    </template>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import FilterBox from './FilterBox.vue'
// import DimPicker from './DimPicker.vue'
import { getDefaultsAsValues } from '@/utils/dataUtils'
import QuickFilter from './QuickFilter.vue'
import DropdownList from './DropdownList.vue'
import TypedFilterBox from './TypedFilterBox.vue'
import chartUtils from '@/utils/chart'
export default {
  components: { FilterBox, draggable, QuickFilter, DropdownList, TypedFilterBox },

  // NO SE ESTA USANDO ESTE "VMODEL" tampoco... pero parece que va...

  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    options: {},
    metas: {},
    value: {},
    role: {},
    mode: {
      default: 'dropdown',
    },
    component: {
      default: 'table',
    },
    chartType: {
      default: null,
    },
    maxItems: {
      default: 2,
    },
  },
  data() {
    return {
      dimensions: JSON.parse(JSON.stringify(this.value.dimensions)),
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        ghostClass: 'ghost',
        delay: this.isMobile ? 400 : null,
        handle: '.drag-handle',
      }
    },
    // dimensions: {
    //   get() {
    //     return JSON.parse(JSON.stringify(this.value.dimensions))
    //   },
    //   set(activeSorted) {
    //     activeSorted = JSON.parse(JSON.stringify(activeSorted))
    //     activeSorted.forEach((d, i) => (d.index = i))
    //     this.$emit('change', { ...this.value, dimensions: activeSorted })
    //   },
    // },
    inactiveDimensions() {
      return (this.dimensions?.filter(d => d.role !== this.role && d.role !== 'types') || []).map(
        d => {
          return {
            id: d.id,
            label: this.metas[d.id].label,
          }
        }
      )
    },
    timeDim() {
      return this.dimensions.find(d => {
        return this.metas[d.id]?.type === 'time'
      })
    },
    fixedDimensions() {
      if (chartUtils[this.chartType]?.fixedDimensions)
        return chartUtils[this.chartType].fixedDimensions(this.dimensions, this.metas)
      else return []
    },
    disabledDimensions() {
      if (chartUtils[this.chartType]?.disabledDimensions)
        return chartUtils[this.chartType].disabledDimensions(this.dimensions, this.metas)
      else return []
    },
    activeDimensions: {
      get() {
        let filtered = this.dimensions.filter(dim => dim.role === this.role)
        if (
          this.mode === 'quick' &&
          (this.component === 'chart' || this.component === 'map') &&
          this.timeDim &&
          this.timeDim.role === 'filters' &&
          this.role === 'filters'
        ) {
          filtered = filtered.filter(d => d.id !== this.timeDim.id)
        }
        filtered.sort((a, b) => a.index - b.index)
        return filtered
      },
      set(actives) {
        let tmp = [...this.dimensions]
        actives.forEach(a => {
          // a.role = this.role
          this.changeRole(a, this.role)
          tmp.splice(
            this.dimensions.findIndex(dd => dd.id === a.id),
            1,
            a
          )
        })
        tmp.sort((a, b) => {
          return actives.findIndex(s => s.id === a.id) - actives.findIndex(s => s.id === b.id)
        })
        if (JSON.stringify(tmp) !== JSON.stringify(this.dimensions)) {
          this.dimensions = tmp
        }
      },
    },
    typeDimensions: {
      get() {
        let filtered = this.dimensions.filter(dim => dim.role === 'types')
        filtered.sort((a, b) => a.index - b.index)
        return filtered
      },
      set(actives) {
        let tmp = [...this.dimensions]
        actives.forEach(a => {
          // a.role = this.role
          // this.changeRole(a, this.role)
          tmp.splice(
            this.dimensions.findIndex(dd => dd.id === a.id),
            1,
            a
          )
        })
        tmp.sort((a, b) => {
          return actives.findIndex(s => s.id === a.id) - actives.findIndex(s => s.id === b.id)
        })
        if (JSON.stringify(tmp) !== JSON.stringify(this.dimensions)) {
          this.dimensions = tmp
        }
      },
    },
    restrictedOptions() {
      // SOLO se restringen las dims que tienen una "dim_type" asociada
      let locaId = Object.keys(this.metas).find(p => this.metas[p].type === 'location')
      let restrictedOptions = this.dimensions.reduce((res, dim) => {
        let typeDim = this.dimensions.find(d => {
          return d.id === dim.id + '_type' 
        })
        if (typeDim) {
          res[dim.id] = this.options[dim.id].filter(d =>
            typeDim.values.find(tv => tv.type === d.type)
          )
        } else {
          if (dim.id.indexOf('_type') >= 0) {
            res[dim.id] = this.metas[dim.id.replace('_type', '')].typeOptions
          } else {
            res[dim.id] = this.options[dim.id]
          }
        }
        //PARSE DE types AQUI
        if (this.mode === 'quick' && this.component === 'map' && dim.id.substring(0, dim.id.length - 5) === locaId)
          res[dim.id] = res[dim.id].filter(o => {
            let arrayGeo = ['districte', 'barri', 'àrea estadística bàsica', 'secció censal']
            if (arrayGeo.indexOf(o.type?.toLowerCase()) !== -1) {
              return o
            }
          })
          
        //AUNQUE haya type=municipi, no hay que mostrarlo porque queda "feo" el mapa con un solo color...
        // if (this.mode === 'quick' && this.component === 'map')
        //   res[dim.id] = res[dim.id].filter(o => o.type?.toLowerCase() !== 'municipi')
        return res
      }, {})
      return restrictedOptions
    
    },
    typeDimOptions() {
      console.log('this.metas', this.metas)
      let res = Object.keys(this.metas).reduce((dict, key) => {
        let meta = this.metas[key]
        dict[meta.id] = meta.typeOptions
        if (meta.type === 'time') {
          let orderedTimeOptions = [
            'període',
            'any',
            'curs',
            'semestre',
            'trimestre',
            'bimestre',
            'mes',
            'setmana',
            'dia',
          ]
          let ordTime = []
          orderedTimeOptions.forEach(el => {
            let findObj = meta.typeOptions.find(elem => elem.type.toLowerCase() === el)
            if (findObj) ordTime.push(findObj)
          })
          dict[meta.id] = ordTime
        }
        if (meta.type === 'location') {
          let orderedLocOptions = [
            'unió europea',
            'estat',
            'país',
            'comunitat autònoma',
            'àmbit funcional territorial',
            'província',
            'municipi',
            'àrea metropolitana',
            'districte',
            'barri',
            'àrea estadística bàsica',
            'secció censal',
          ]
          let ordLoc = []
          orderedLocOptions.forEach(el => {
            let findObj = meta.typeOptions.find(elem => elem.type.toLowerCase() === el)
            if (findObj) ordLoc.push(findObj)
          })
          dict[meta.id] = ordLoc
        }
        return dict
      }, {})
      return res
    },
  },
  
  watch: {
    dimensions: {
      handler(activeSorted) {
        activeSorted = JSON.parse(JSON.stringify(activeSorted))
        activeSorted.forEach((d, i) => (d.index = i))
        if (JSON.stringify(activeSorted) !== JSON.stringify(this.value.dimensions)) {
          this.$emit('change', { ...this.value, dimensions: activeSorted })
        }
      },
      deep: true,
    },
    value: {
      handler() {
        this.dimensions = JSON.parse(JSON.stringify(this.value.dimensions))
      },
      immediate: true,
    },
    restrictedOptions: {
      handler() {
        //Se sanitiza TODAS las dimensions no solo las "active" de ESTE PivotConfigGroup
        let sanitized = this.sanitize(this.dimensions)
        this._latestRestrictedOptions = Object.keys(this.restrictedOptions).reduce((dict, key) => {
          dict[key] = this.restrictedOptions[key] && this.restrictedOptions[key].map(o => o.id)
          return dict
        }, {})
        if (sanitized) this.dimensions = sanitized
      },
      immediate: true,
    },
  },
  methods: {
    getChartUtil(chartType) {
      return chartUtils[chartType] || {}
    },
    sanitize(dimensions) {
      // remove values that are no longer in the options
      let restrictedValue = JSON.parse(JSON.stringify(dimensions)).map(dim => {
        return {
          ...dim,
          values: dim.values.filter(v =>
            this.restrictedOptions[dim.id].find(o => o.id === v.value)
          ),
        }
      })

      // fill default Multis IF the "restrictedOptions" for the [dim] have actually changed
      let optionsEqu = dimId => {
        let opts1 = this.restrictedOptions[dimId]
        let opts2 = this._latestRestrictedOptions && this._latestRestrictedOptions[dimId]
        if (!opts1 || !opts2) return false
        opts1 = opts1.map(o => o.id)
        if (opts1.length != opts2.length) return false
        else return opts1.every(o => opts2.indexOf(o) >= 0)
      }
      // if (this.role !== 'filters') {
      restrictedValue.forEach(dim => {
        if (dim.role !== 'filters') {
          if (this._latestRestrictedOptions && !optionsEqu(dim.id)) {
            dim.values = getDefaultsAsValues(this.restrictedOptions[dim.id], 'defaultMulti')
            // dim.values = getDefaultsAsValues(
            //   this.restrictedOptions[dim.id].length > 100
            //     ? this.restrictedOptions[dim.id].slice(
            //         this.restrictedOptions[dim.id].length - 100,
            //         this.restrictedOptions[dim.id].length
            //       )
            //     : this.restrictedOptions[dim.id],
            //   'defaultMulti'
            // )
          }
        }
      })
      // }
      // fill with defaultSingle any "values" that ended up with emtpy array []
      restrictedValue.forEach(dim => {
        // con la segunda condicion, permitimos que si el usuario ha hecho deselectAll se quede vacio
        if (dim.values.length === 0 && dimensions.find(d => d.id === dim.id).values.length !== 0) {

          dim.values = getDefaultsAsValues(this.restrictedOptions[dim.id])
        }
      })


      // only return a value if actual changes
      if (JSON.stringify(restrictedValue) !== JSON.stringify(dimensions)) {
        console.log('should sanitize. Sanitized: ', restrictedValue)
        return restrictedValue
      } else {
        return null
      }
    },
    checkMove(evt) {
      let draggedDim = this.dimensions.find(d => d.id === evt.dragged.getAttribute('data-id'))
      let targetActives = evt.to.parentNode.parentNode.__vue__.activeDimensions
      let pushedDim = targetActives[evt.draggedContext.futureIndex]
      let targetType = evt.to.getAttribute('data-type')
      let targetMaxItems = +evt.to.getAttribute('data-max-items')
      let targetChildren = this.dimensions.filter(dim => dim.role === targetType).length

      if (
        this.fixedDimensions.find(fd => fd.id === draggedDim.id) ||
        (pushedDim && this.fixedDimensions.find(fd => fd.id === pushedDim.id))
      )
        return false
      else if (
        evt.to !== evt.from &&
        targetChildren >= targetMaxItems &&
        (targetType === 'rows' || targetType === 'columns' || targetType === 'chart')
      )
        return false
      else return true
    },
    canDrag(dim) {
      return !this.fixedDimensions.find(d => d.id === dim.id)
    },
    canEdit(dim) {
      return !this.disabledDimensions.find(d => d.id === dim.id)
    },
    onDimChange(dim, newDim) {
      let tmp = [...this.activeDimensions]
      tmp.splice(this.activeDimensions.indexOf(dim), 1, newDim)
      this.activeDimensions = tmp
    },
    onTypeDimChange(dim, newDim) {
      let tmp = [...this.typeDimensions]
      tmp.splice(this.typeDimensions.indexOf(dim), 1, newDim)
      this.typeDimensions = tmp
    },
    removeDimension(dim) {
      let dimension = this.dimensions.find(d => d.id === dim)
      this.changeRole(dimension, 'filters')
    },
    addDimension(dim) {
      let dimension = this.dimensions.find(d => d.id === dim)
      this.changeRole(dimension, this.role)
    },
    changeRole(dimension, role) {
      let usedDims = this.dimensions.filter(
        el => el.role !== 'types' && el.role !== 'filters' && el.id !== dimension.id
      )
      let oposide
      if (role === 'rows') oposide = 'columns'
      else if (role === 'columns') oposide = 'rows'
      let notPossible = false
      if (
        usedDims.length > 0 &&
        usedDims.find(el => el.role === oposide) === undefined &&
        role !== 'filters' &&
        role !== 'chart'
      )
        notPossible = true
      if (dimension.role === role || notPossible) return
      else {
        dimension.role = role

        //Aseguramos que se mantiene el orden de las fixed dimensions
        if (this.fixedDimensions && this.fixedDimensions.length) {
          let bubbledIndex =
            this.fixedDimensions.map(d => d.index).reduce((max, d) => Math.max(d, max), -Infinity) +
            1
          if (dimension.index !== bubbledIndex) {
            dimension.index = bubbledIndex
            this.dimensions.sort((a, b) => a.index - b.index)
          }
        }

        let defeaultKey
        if (role === 'filters') defeaultKey = 'defaultSingle'
        else if (role === 'rows' || this.role === 'columns' || this.role === 'chart')
          defeaultKey = 'defaultMulti'
        console.log('changing roel of', dimension)
        let typeDim = this.dimensions.find(d => d.id === dimension.id + '_type')
        dimension.values = getDefaultsAsValues(this.restrictedOptions[dimension.id], defeaultKey)
        if (typeDim) {
          if (this.metas[dimension.id].type === 'time') defeaultKey = 'defaultSingle' //EXCEPION para "time"
          typeDim.values = getDefaultsAsValues(this.typeDimOptions[dimension.id], defeaultKey)
          typeDim.values.forEach(
            e =>
              (e['labelType'] =
                this.metas[dimension.id].typeOptions.find(el => el.type === e.type)?.label ||
                e.type)
          )
        }
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
// @xavi CUIDAO que aixo esta tant al panel de la dreta com als quickfilters de dalt!!!!
// NO shauria de tocar casi RES aqui!
.pivot-config-group
  &.dropdown
    display: flex
    flex-direction: column

  &.quick
    align-items: center
    display: flex
    // flex: 1 1 0%
    flex-wrap: wrap
    gap: vw(10px)

    &:not(:empty)
      margin-right: vw(25px)
      padding-right: vw(25px)

      .mobile &
        margin-right: 0

    .mobile &
      &:only-child
        margin-right: 0

  // .quick-filter-container
  // &:not(:last-child)
  // position: relative
  // margin-right: vw(25px)
  // padding-right: vw(25px)

  // .mobile &
  // flex: 1 1 0%
  // margin-bottom: vw(10px)
  // // margin-right: 0
  // padding-right: 0

  // &:after
  // position: absolute
  // top: 0
  // right: 0
  // width: 1px
  // height: 100%
  // background-color: $seat-ocre
  // content: ""

  // .mobile &
  // display: none
  .dropdown-list
    >>> .filter
      cursor: grab

      &.nodrag
        cursor: default

        .filter-box-icon,
        .remove
          display: none

        .filter-box
          background-color: #fff
          // border: solid 1px #f0f0f0;

      &.noedit
        opacity: 0.6
        pointer-events: none

      &.ghost
        opacity: 0

    .no-dims-message
      opacity: 0.3
      text-align: center

    .drag-more-message
      m-font-size(12, 16)
      m-letter-spacing(50)
      border: 1px dotted $bcn-grey-y
      color: $grey
      margin-top: vw(10px)
      opacity: 0.7
      padding: vw(15px)
      text-align: center
      user-select: none
      /* three items */

    .drag-more-message:nth-child(1):nth-last-child(3),
    .drag-more-message:nth-child(2):nth-last-child(2),
    .drag-more-message:nth-child(3):nth-last-child(1)
      display: none
</style>
